'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Styles = require('./TargetDateSeriesCategoriesTable.css');

var TargetDateSeriesCategoriesTable = (_dec = (0, _reactCssModules2.default)(Styles, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(TargetDateSeriesCategoriesTable, _Component);

  function TargetDateSeriesCategoriesTable(props) {
    (0, _classCallCheck3.default)(this, TargetDateSeriesCategoriesTable);
    return (0, _possibleConstructorReturn3.default)(this, (TargetDateSeriesCategoriesTable.__proto__ || (0, _getPrototypeOf2.default)(TargetDateSeriesCategoriesTable)).call(this, props));
  }

  (0, _createClass3.default)(TargetDateSeriesCategoriesTable, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          iyvConfigCategories = _props.iyvConfigCategories,
          targetDateSeries = _props.targetDateSeries;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'table',
          { styleName: 'tds-cats-tbl card' },
          _react2.default.createElement(
            'thead',
            null,
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'th',
                null,
                'Screen'
              ),
              _react2.default.createElement(
                'th',
                null,
                '# of holdings'
              ),
              _react2.default.createElement(
                'th',
                null,
                '% of portfolio'
              )
            )
          ),
          _react2.default.createElement(
            'tbody',
            null,
            iyvConfigCategories.map(function (e, i) {
              return _react2.default.createElement(
                'tr',
                { key: 'cnfg-cats-' + i },
                _react2.default.createElement(
                  'td',
                  null,
                  e.lbl
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  targetDateSeries[e.cnt]
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  _format2.default.perc(targetDateSeries[e.wght])
                )
              );
            })
          )
        )
      );
    }
  }]);
  return TargetDateSeriesCategoriesTable;
}(_react.Component), _class2.propTypes = {
  // the config for this set of IYV categories
  iyvConfigCategories: _react.PropTypes.array.isRequired,
  // the target date series object
  targetDateSeries: _react.PropTypes.object.isRequired
}, _temp)) || _class);
exports.default = TargetDateSeriesCategoriesTable;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TargetDateSeriesCategoriesTable/TargetDateSeriesCategoriesTable.js
// module id = 1445
// module chunks = 0